import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-homeeight-intro',
    templateUrl: './homeeight-intro.component.html',
    styleUrls: ['./homeeight-intro.component.scss']
})
export class HomeeightIntroComponent implements OnInit {

    constructor() {}

    ngOnInit(): void {}

    // Video Popup
    isOpen = false;
    openPopup(): void {
        this.isOpen = true;
    }
    closePopup(): void {
        this.isOpen = false;
    }

}